const sobradoStageApiUrl: string = 'https://stage.sobrado.ch';
const gatewayStageApiUrl: string = 'https://gateway.stage.sobrado.ch';
const platformSobradoStageApiUrl: string = 'https://platform.stage.sobrado.ch';
const sngFlowableWorkApiUrl: string = 'https://work.fl.stage.sobrado.ch';
const votingPortalApiUrl: string = 'https://bvg.stage.sobrado.ch';

export const environment = {
  name: 'stage',
  production: false,
  hasCacheTranslate: false,
  hashTranslate: `${new Date().getTime()}`,
  localhostUrl: 'http://localhost',
  sngLink: `${platformSobradoStageApiUrl}/`,
  sobradoUrl: sobradoStageApiUrl,
  apiUrl: `${sobradoStageApiUrl}/`,
  authApiUrl: `${sobradoStageApiUrl}/api-platform/oauth`,
  iframeAuthApiUrl: `${sobradoStageApiUrl}/api-platform/iframes`,
  publicEntryPointAuthApiUrl: `${sobradoStageApiUrl}/api-platform/entrypoint/public-link-jwt`,
  sharedLinkAuthApiUrl: `${sobradoStageApiUrl}/api-platform/generate-guest-jwt`,
  redirectLinkUrl: `${sobradoStageApiUrl}/`,
  apiGraphQl: `${gatewayStageApiUrl}/graphql`,
  gatewayUrl: `${gatewayStageApiUrl}/`,
  sharedLinkUrl: `${platformSobradoStageApiUrl}/`,
  sobradoLoginUrl: 'https://login.stage.sobrado.ch/',
  sngFlowableWorkApiUrl: `${sngFlowableWorkApiUrl}`,
  sngFlowableCustomStyleUrl: `${sngFlowableWorkApiUrl}/ext/custom.css`,
  votingPortalApiUrl: `${votingPortalApiUrl}/`,
  getMoreBrainUrl: 'https://sobrado.getmorebrain.com',
  feedbackEmail: 'info@sobrado.ch',
  s3BucketDomainUrl: 'cloudscale.ch',
  supersetDomain: 'https://analytics.stage.sobrado.ch/',
  matomo: {
    trackerUrl: '',
    siteId: '',
    cookieDomain: '',
  },
  powerBiSettings: {
    factsheetReportId: '31bc7162-4173-4a69-a250-bc0844e1f1c7',
    pensionReportId: 'c756dcb2-acf9-4390-a96c-05a3247aee38',
  },
  defaultMaintenancePageUrl: 'https://panoramix.sobrado.ch/off/',
  // eslint-disable-next-line max-len
  spreadJsLicenseKey: '*.sobrado.ch,261446764331496#B1mNMNXNwllcrFTcKh4LxgjdCdEZ64WbBJWWm56TxNVcOp4LtNTbX54Tnd5bJVXOrk7cupnauNjYI3mVvQ7Q6hFSixkQZ56a6YXZaN4V0VDSyw4Tptyd4JjSmNEdltmavA7VXJWZxsWdIl4Ul94d5d5SllDVIZ7LrUDWCVUSTl4RidEZUxkNPNmeSdzY5YjZRR5c55ENRtUc8FEa4cVREpkRNJUZFFESXhFSIVUeJd5LKR7UaZjTzFUd4NVSVFWVYx6SON6NkJzLkNHdzhHZRlVb6F4LHZVRUh6UxBzK0FnVhRUNyF7QB5mZ7skUY3CMv8kUiojITJCLiYTNEFURBZjI0ICSiwiMyETM7kDN7UTM0IicfJye35XX3JyUQRlSiojIDJCLikTMuYHITpEIkFWZyB7UiojIOJyebpjIkJHUiwiIzMzMyYDMgUTM4AjNyAjMiojI4J7QiwiIoNmLvRWYyJ6bz9iKiojIz5GRiwiIHFEIlJXY7RnZvNFIvRWYyJ6bTJiOiEmTDJCLiYTO4EzMzQjN7YDN4EjNyIiOiQWSiwSfdtlOicGbmJCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPRhTW8tiYHxEa4o6ZXpXYsBXRjNVb9AXTNZzcrg7UVlVazFURU3SSLRVbxJDauVESKRGRGJkZrZkNx2ydHFjV8cGS7k6TRtSMxF4TihHWwJkRpZmRUhXQDNTSplUTxpVemZnZ5V',
  // eslint-disable-next-line max-len
  spreadJsDesignerLicenseKey: 'Sobrado Software AG,*.sobrado.ch,998112877843727#B1wYZWHlkWl36UrNXOBR6KslVTrMka0RDZBdUTw44aXN5coR5NzoWb5oVTzUmZq5kQ8Q7YQZFRq3yKvo6NBNEMwQHMllTNMFXOmJEa4MkYpZUbqNzZ7Ajc0V7awlVcuZkNSFlUBdEMpZlM4MjavAXTklHT4MWaxpGUzI4ZEVEOwJUQ5UFcro5RvhHO5dkWL5mMSR7b5NnWw3UeqF5bPhVcER7Q9EERO3WbjRnYzB5R8ZHNy3SczYmQz96drIlQohzLr2Wa9MmatZ7NINVZwJXVhZGbSRlYaR7VTZjVOpnNMZXMCFDdTxUWrcnUiojITJCLiUUM4YDNEJ4NiojIIJCLzgTM8MjMzUjN0IicfJye35XX3JiNLp4MiojIDJCLikTMuYHIu3GZkFULyVmbnl6clRULTpEZhVmcwNlI0IiTis7W0ICZyBlIsISOxUjM6ADI5EDNwYjMwIjI0ICdyNkIsICaj9ybkFmci36cuoiI0IyctRkIsIyRBBSZyF6d4Z6bTBybkFmci36UiojIh94QiwiI7IzNzQDO7cDOyETM8kTOiojIklkI1pjIEJCLi4TP7lWcZN7MM3EZjNHMxdWZ6h4R8F4NIF6M8lUc54UaMRHZPVDdBtGeDB5MzoWOxBjc7ZVbXRzc4QFev44Ln34RP3CdoFzLYlXUlF7KkB5Z5RGZE9WUxZVYRNlUvFEUqJUSvgHbiBjd5UnVvFVc',
  sentry: {
    dsn: 'https://930f66a3c382b2c1fdd8f8a688d1c586@o302940.ingest.us.sentry.io/4508681482993664',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    tracePropagationTargets: [sobradoStageApiUrl, gatewayStageApiUrl, platformSobradoStageApiUrl,
      sngFlowableWorkApiUrl],
  },
  oidcSettings: {
    authority: `${sobradoStageApiUrl}/api-platform/oauth/authorize`,
    client_id: 'sng',
    // not required, page to finish authorisation process and redirect back to required page
    redirect_uri: `${platformSobradoStageApiUrl}/oidc-callback`,
    response_type: 'code',
    scope: 'offline_access profile flowable',
    prompt: 'none', // allow not to ask to Approve login
    metadata: {
      authorization_endpoint: `${sobradoStageApiUrl}/api-platform/oauth/authorize`,
      token_endpoint: `${sobradoStageApiUrl}/api-platform/oauth`,
      end_session_endpoint: `${sobradoStageApiUrl}/auth/logout`,
      revocation_endpoint: `${sobradoStageApiUrl}/api-platform/oauth/revoke`,
    },
  },
};
